import React from 'react';
import { Link } from 'react-router-dom';
const Portfolio = () => {
    return (
        <section id="portfolio" className="portfolio">
            <h2>For you to see!</h2>
            <div className="menu">
                
                <Link to="/projects">Projects</Link>
            </div>
        </section>
    );
};

export default Portfolio;
